import { fetchSingleTestCase } from 'actions';
import TestCase from 'components/TestCase';
import GlobalTestPage from 'components/TestPage/GlobalTestPage';
import TestPageAdmin from 'components/TestPageAdmin';
import TestResultsVisualizerPage from 'components/TestResultsVisualizer/TestResultsVisualizerPage';
import { RouteSpec, SuperRouteSpec } from 'types';

const testCasesRoutes: (RouteSpec | SuperRouteSpec)[] = [
  {
    name: 'test-cases-detail',
    path: '/:customerDomain/test-cases/:testCaseId',
    component: TestCase,
    private: true,
    permissions: 'test_cases.list',
    data: {
      idFromPath: true,
      actions: [fetchSingleTestCase],
    },
  },
  {
    name: 'test-viz-result',
    path: '/:customerDomain/test-viz-result',
    component: TestResultsVisualizerPage,
    permissions: 'test_cases.list',
    private: true,
  },
  {
    name: 'test-viz',
    path: '/:customerDomain/test-viz',
    component: GlobalTestPage,
    permissions: 'test_cases.customerTestPage',
    private: true,
    data: {
      params: {
        body_visualizer: {},
      },
    },
  },
  {
    name: 'test-viz-admin',
    path: '/:customerDomain/test-viz-admin',
    component: TestPageAdmin,
    private: true,
    permissions: 'test_cases.list',
    data: {
      params: {
        body: {},
      },
    },
  },
  {
    path: '/test-viz-admin',
    component: (): null => null,
    private: true,
  },
];

export default testCasesRoutes;
